import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ListLayer from "../../components/HelpSupport/HelpSupportListLayer";


const HelpSupportList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Help & Support" />

        {/* UsersListLayer */}
        <ListLayer />

      </MasterLayout>

    </>
  );
};

export default HelpSupportList; 
